module.exports = __webpack_public_path__ + "img/champ_girl_2022.579ee625.png";